export default __webpack_public_path__ + "static/media/sweet-2.39b3a07e.png";